<template>
  <b-tab title="Certificado" :active="ativo" class="m-0 p-0">
    <div id="screen-form" class="pl-2 pr-2 mt-2">
      <div id="CertificadoDeQualidade">
        <b-container fluid>
          <!-- ::::::::::::::: PARTE SUPERIOR DO RELATORIO ::::::::::::::: -->
          <b-row>
            <b-col cols="3">
              <b-img :src="require('/static/images/netech.png')" fluid alt="Responsive image" width="230" />
            </b-col>

            <b-col cols="6" class="pt-4">
              <h4 class="exo-2 center-text p-4">CERTIFICADO DE QUALIDADE</h4>
            </b-col>

            <b-col cols="3" class="pl-5">
              <b-row><p class="m-0 p-0">ID. Relatório</p></b-row>
              <b-row><b-form-input size="sm" v-model="certificado.numero" /></b-row>
              <b-row><p class="m-0 p-0">Data</p></b-row>
              <b-row>
                <b-form-datepicker
                  size="sm"
                  v-model="certificado.data"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                />
              </b-row>
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>INFORMAÇÕES DO SERVIÇO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="6" class="p-0">
              <p class="m-0 p-0">Cliente / Client</p>
            </b-col>
            <b-col cols="6" class="p-0 pl-2">
              <p class="m-0 p-0">Local da Execução / Place of Execution</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6" class="p-0 pl-2">
              <b-form-input size="sm" v-model="cliente.nome" />
            </b-col>
            <b-col cols="6" class="p-0 pl-2">
              <b-form-input size="sm" v-model="certificado.local" />
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0">Nº Pedido / Purchase Order no.</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <p class="m-0 p-0">Nº Ordem de Serviço / Service Order no.</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-4">
              <p class="m-0 p-0">Documento Técnico / Technical Document</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="certificado.pedido" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="certificado.ordem" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="certificado.documento" />
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>IDENTIFICAÇÃO DO EQUIPAMENTO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0">Equipamento / Equipment</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <p class="m-0 p-0">Identificação / Identification</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-4">
              <p class="m-0 p-0">Código / Serial no.</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.nome" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.sgcq" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.codigo" />
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0">Dimensões / Dimensions</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <p class="m-0 p-0">Fabricante / Manufacturer</p>
            </b-col>
            <b-col cols="2" class="p-0 pl-4">
              <p class="m-0 p-0">Peso / Weight</p>
            </b-col>
            <b-col cols="2" class="p-0 pl-4">
              <p class="m-0 p-0">Carga / Work load</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.dimensoes" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.fabricante" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.peso" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.carga" />
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>REGISTRO FOTOGRÁFICO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="fotos == 'single'">
            <b-col cols="12" class="p-0">
              <div class="p-2 m-0">
                <b-img
                  :src="imagemA == null ? require('/static/images/default.png') : imagemA"
                  class="mt-2 max-size"
                  center
                  fluid
                />
              </div>
            </b-col>
          </b-row>
          <b-row v-if="fotos == 'double'">
            <b-col cols="6" class="p-0">
              <div class="p-2 m-0">
                <b-img
                  :src="imagemA == null ? require('/static/images/default.png') : imagemA"
                  class="mt-2 max-size"
                  center
                  fluid
                />
              </div>
            </b-col>
            <b-col cols="6" class="p-0">
              <div class="p-2 m-0">
                <b-img
                  :src="imagemB == null ? require('/static/images/blank.png') : imagemB"
                  @dblclick="fotos = 'single'"
                  class="mt-2 max-size"
                  center
                  fluid
                />
              </div>
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>ETAPAS DA CERTIFICAÇÃO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <b-list-group>
                <b-list-group-item
                  v-for="item in certificado.itens"
                  :key="item.id"
                  class="d-flex justify-content-between align-items-center"
                >
                  {{ item.message }}
                  <b-badge :variant="item.variant" class="text-right">{{ item.result }}</b-badge>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>DETALHES DA CERTIFICAÇÃO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0">Procedimento / Procedure</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <p class="m-0 p-0">Resultado / Result</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-4">
              <p class="m-0 p-0">Próxima Inspeção / Next Inspection</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="certificado.procedimento" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="certificado.resultado" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-datepicker
                size="sm"
                v-model="certificado.proxima"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
              />
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="12" class="p-0">
              <p class="m-0 p-0">Observações / Comments</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="p-0 pl-2">
              <b-form-textarea v-model="certificado.observacao" :rows="linhas" />
            </b-col>
          </b-row>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::: PARTE INFERIOR DO RELATORIO DE LAUDO ::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>INSPETOR</strong>
              </div>
            </b-col>
            <b-col cols="4" class="mt-2 p-0">
              <div class="separador-div">
                <strong>RESPONSÁVEL</strong>
              </div>
            </b-col>
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>CLIENTE</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left ml-2 mr-2 mb-2">
            <b-col cols="4">
              <inspetor-stamp
                :profissional="certificado.inspetor"
                :preview="stampInspetor"
                :posicao="'6rem'"
                key="insp-stamp-cert"
              />
            </b-col>
            <b-col cols="4" class="m-0 p-0">
              <responsavel-stamp
                :profissional="certificado.responsavel"
                :preview="stampResponsavel"
                :posicao="'6rem'"
                key="resp-stamp-cert"
              />
            </b-col>
            <b-col cols="4">
              <div class="borda-cliente">
                <b-img
                  :src="logoCliente == null ? require('/static/images/sgcq_default.png') : logoCliente"
                  class="rounded-0"
                  fluid
                />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <certificado-modal ref="tCertificado" @loadCertificado="loadCertificado($event)" />
    <imagem-list-modal ref="imgListCertificado" @loadImagem="loadImagem($event)" />
    <!-- ::::::::::::::: COMANDOS DO RELATÓRIO ::::::::::::::: -->
    <div class="menu-acoes p-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <h4 class="exo-1 m-0 mr-2">SGCQ</h4>
            <b-form-input id="sgcq-call" type="number" size="sm" class="m-1 p-1" placeholder="Sgcq" v-model="sgcq" />
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="primary" @click="loadEquipamento()">
              <b-icon icon="box-arrow-in-up-right" variant="light" scale="1.1" class="mr-2" />Buscar
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="loadDetalhes()">
              <b-icon icon="file-earmark-richtext" variant="light" scale="1.1" class="mr-2" />Detalhes
            </b-button>
            <b-button size="sm" class="ml-2 pl-2 pr-3" variant="warning" v-print="printLaudo">
              <b-icon icon="printer" variant="light" scale="1.1" class="mr-2" />Imprimir
            </b-button>

            <b-form-radio-group
              id="radio-group-1"
              v-model="fonteDaImagem"
              name="radio-sub-component"
              buttons
              button-variant="outline-light"
              size="sm"
              class="conf-bar"
            >
              <b-form-radio value="equipamento">Equipamento</b-form-radio>
              <b-form-radio value="banco">Banco de Imagem</b-form-radio>
            </b-form-radio-group>

            <b-form-input id="size-lines" type="number" size="sm" class="m-1 p-1" v-model="linhas" />
          </b-form>
        </b-col>
      </div>
    </div>
  </b-tab>
</template>
<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import StampCertificado from "@/components/supports/StampCertificado";
import Cliente from "@/models/Cliente";
import Equipamento from "@/models/Equipamento";
import Certificado from "@/models_reports/Certificado";
import CertificadoModal from "@/components/modals/relatorio/CertificadoModal";
import ImagemListModal from "@/components/modals/imagem/ImagemListModal";
import Files from "@/http/files";

export default {
  name: "CertificadoReport",

  components: {
    "certificado-modal": CertificadoModal,
    "inspetor-stamp": StampCertificado,
    "responsavel-stamp": StampCertificado,
    "imagem-list-modal": ImagemListModal,
  },

  data() {
    return {
      sgcq: 0,
      ativo: false,
      certificado: new Certificado(),
      cliente: new Cliente(0, "Novo Cliente", "", "", "", "", "", "", ""),
      equipamento: new Equipamento(0, "Novo Equipamento", "", "", "", "", "", "", "", "", ""),
      stampInspetor: null,
      stampResponsavel: null,
      logoCliente: null,
      fonteDaImagem: "equipamento",
      fotos: "single",
      imagemA: null,
      imagemB: null,
      printLaudo: {
        id: "CertificadoDeQualidade",
        popTitle: "SGCQ - Sistema de Gestão e Controle da Qualidade",
      },
      files: new Files(this.$http),
      linhas: 5,
    };
  },

  watch: {
    fonteDaImagem: function (newValue) {
      this.imagemA = null;
      if (newValue == "banco") {
        this.$refs.imgListCertificado.call();
      }
    },
  },

  methods: {
    loadEquipamento() {
      if (this.sgcq != 0 && this.sgcq != "") {
        this.equipamento.update(this.getBySgcq(this.sgcq)[0]);
        this.cliente.update(this.equipamento.cliente);
        this.equipamentoStore.LISTAR_SERVICOS(this.equipamento.sgcq).then(() => {
          let servicoData = new Date(this.getLastServico[0].data);
          this.certificado.data = new Date(this.getLastServico[0].data);
          let ano = servicoData.getFullYear();
          this.certificado.numero = "RN" + this.getLastServico[0].id + "-" + this.sgcq + "-" + ano + "-CT";
          this.certificado.proxima = new Date(servicoData.setMonth(servicoData.getMonth() + Number(this.certificado.validade)));

          //carrega a imagem do equipamento
          if (this.fonteDaImagem == "equipamento") {
            this.files.downloadEquipamento(this.equipamento.sgcq).then((response) => {
              const reader = new FileReader();
              const blob = new Blob([response]);
              reader.readAsDataURL(blob);
              reader.onload = (e) => {
                this.imagemA = e.target.result;
              };
            });
          }
          //carrega a logomarca do cliente
          this.files.downloadLogo(this.cliente.id).then((response) => {
            const reader = new FileReader();
            const blob = new Blob([response]);
            reader.readAsDataURL(blob);
            reader.onload = (e) => {
              this.logoCliente = e.target.result;
            };
          });
        });
      }
    },

    loadDetalhes() {
      this.$refs.tCertificado.call(this.certificado);
    },

    loadImagem(imagem) {
      this.imagemA = imagem;
    },

    loadCertificado(arquivo) {
      this.fotos = "double";
      const reader = new FileReader();
      const blob = new Blob([arquivo]);
      reader.readAsDataURL(blob);
      reader.onload = (e) => {
        this.imagemB = e.target.result;
      };
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getBySgcq } = storeToRefs(equipamentoStore);
    const { getLastServico } = storeToRefs(equipamentoStore);

    return {
      store,
      equipamentoStore,
      getBySgcq,
      getLastServico,
    };
  },
};
</script>

<style lang="scss" scoped>
.exo-1 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: italic;
  font-size: 1.4rem;
  padding: 0;
  color: white;
}

.exo-2 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: italic;
  font-size: 1.8rem;
  text-align: center;
}

.center-text {
  text-align: justify; /* For Edge */
  text-align-last: center;
}

.separador-div {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  background-color: #003c5a;
  border-radius: 4px;
  color: white;
  text-align: justify; /* For Edge */
  text-align-last: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

#screen-form {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 82vh;
}

#sgcq-call {
  width: 6rem;
}

#size-lines {
  width: 4rem;
}

.menu-acoes {
  background-color: #112a4a;
}

.borda-cliente {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding-top: 1rem;
  padding-left: 3rem;
  min-height: 8.8rem;
}

.bordered {
  border: 1px solid lightgray;
}

.max-size {
  max-height: 20rem;
}

.conf-bar {
  margin-left: 15rem;
}
</style>
